import { LocalizationActionTypes } from './localization.types';

export const setLocaleEn = () => ({
    type: LocalizationActionTypes.LOCALE_SPECIFIC_EN,
});

export const setLocaleHe = () => ({
    type: LocalizationActionTypes.LOCALE_SPECIFIC_HE,
});
